import { render, staticRenderFns } from "./TopUps.vue?vue&type=template&id=51b4738a"
import script from "./TopUps.vue?vue&type=script&lang=js"
export * from "./TopUps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports